import gql from 'graphql-tag';
import PaginatorInfoFragment from '../fragments/PaginatorInfoFragment';
import { CouponListItem } from '../fragments';

export default gql`
query coupons($filters: AdminCouponsFilter, $sortBy: AdminCouponOrder, $count: Int!, $page: Int) {
    coupons(filters: $filters, sortBy: $sortBy, first: $count, page: $page) {
        paginatorInfo {
            ...PaginatorInfoFragment
        }
        data {
            ...CouponListItem
        }
    }
}
${PaginatorInfoFragment}
${CouponListItem}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/queries/coupons.ts